import * as types from "../constants";
import ActionRequest from "../../../utils/requests/actionRequest";
import PromotorsApi from "../../../models/PromotorsApi";

export function loadPromotorsSetCurrent(promotorId) {
  let action = new ActionRequest(
    PromotorsApi.setCurrentPromotor,
    loadPromotorsSetCurrentInit,
    loadPromotorsSetCurrentSuccess,
    loadPromotorsSetCurrentFailure
  );
  return action.run({
    routeParameters: { promotorId },
    actionParameters: { promotorId },
  });
}

function loadPromotorsSetCurrentSuccess(promotorsSetCurrentData, params) {
  return {
    type: types.SET_CURRENT_PROMOTOR_SUCCESS,
    data: promotorsSetCurrentData,
  };
}

function loadPromotorsSetCurrentFailure(error) {
  return {
    type: types.SET_CURRENT_PROMOTOR_FAILURE,
    notification: {
      level: "error",
      label: "[action:promotorsSetCurrent>loadPromotorsSetCurrent]",
      message: "Impossible de récupérer la liste des promotorsSetCurrent",
      system_message: error.message,
    },
  };
}

function loadPromotorsSetCurrentInit(params) {
  return { type: types.SET_CURRENT_PROMOTOR_INIT };
}
